import React, { useState } from 'react';
import {  Modal } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

const CopyUserLink = ({ children, url }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);

  const onCopyText = () => {
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 1000);
  };

  const handleClose = () => {
    setShow(false);
    setCopySuccess(false);
  };
  const handleShow = () => {
    setShow(true);
  }



  return (
    <>
      <CopyToClipboard>
      <div className="cursor-pointer" onClick={handleShow}>
        {children}
      </div>
      </CopyToClipboard>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="sm"
        dialogClassName={'copy-profile-link-modal copy-profile-link-modal-container'}>
        <Modal.Body
          className={'d-flex flex-column justify-content-center align-items-center copy-profile-link-modal-content'}
        >
          <div className="link-box">{t('Link Coped!')}</div>
          <p className="copy-link-separator"></p>
          <CopyToClipboard text={url} onCopy={onCopyText}>
            <button className="btn btn-primary-outline btn-padding" onClick={handleClose}>
              {copySuccess ? handleClose : <span className="text-green font-weight-bold">{t('OK')}</span>}
            </button>
          </CopyToClipboard>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CopyUserLink;


